export var NOTIFIER_NAME = 'airbrake-js/browser';
export var NOTIFIER_VERSION = '1.4.1';
export var NOTIFIER_URL = 'https://github.com/airbrake/airbrake-js/tree/master/packages/browser';
//# sourceMappingURL=version.js.map